import { ChangeEvent, useEffect, useRef, useState } from "react";
import AdminNavBar from "./AdminNavBar";
import TimesheetNavBar from "./TimesheetNavBar";
import { FetchActiveUsers, User, UserSelect } from "./UserSelect";
import { SelectInstance } from "react-select";

const EditTime = () => {
	interface Unit {
		id: number;
		unit: string;
		active: boolean;
	}
	interface clockEntry {
		entryID: number[]
		userID: number
		clockIn: string
		clockOut: string
		date: string
		unit: string
		unitID: number
		location: string
		locationID: number
	}
	interface Location {
		active: boolean
		id: number
		long_name: string
		short_name: string
	}

	
	interface Option {
		value: any;
		label: string;
	}

	var userRef = useRef<HTMLSelectElement>(null)
	var dateRef = useRef<HTMLSelectElement>(null)
	var selectRef = useRef<SelectInstance<Option | null>>(null)

	const clockInRefs = useRef<Map<number, HTMLInputElement>>(new Map());
	const clockOutRefs = useRef<Map<number, HTMLInputElement>>(new Map());
	const unitRefs = useRef<Map<number, HTMLSelectElement>>(new Map());
	const locationRefs = useRef<Map<number, HTMLSelectElement>>(new Map());
	const entryDateRef = useRef<Map<number, HTMLInputElement>>(new Map());

	const [isUserSet, setIsUserSet] = useState(false)
	const [users, setUsers] = useState<User[]>([])
	const [selectedUser, setSelectedUser] = useState<User>({ id: 0, first_name: "", middle_name: "", last_name: "", signed_in: false, photo: "", active: false, email: "", password: "", role: "" })
	const [dates, setDates] = useState<string[]>([])
	const [clockEntries, setClockEntries] = useState<clockEntry[]>([])
	const [units, setUnits] = useState<Unit[]>([])
	const [locations, setLocations] = useState<Location[]>([])
	const [msg, setMsg] = useState("")

	const getUnits = async () => {
		const response = await fetch(process.env.REACT_APP_API+"/api/units")
		if (response) {
			const units = await response.json()
			setUnits(units)
		}
	}

	const getLocations = async () => {
		const response = await fetch(process.env.REACT_APP_API+"/api/locations")
		if (response) {
			const locations = await response.json()
			setLocations(locations)
		}
	}

	const getClockInRef = (id: number) => {
		const map = clockInRefs.current;
		return (node: HTMLInputElement | null) => {
			if (node) {
				map.set(id, node);
			} else {
				map.delete(id);
			}
		};
	};

	const getClockOutRef = (id: number) => {
		const map = clockOutRefs.current;
		return (node: HTMLInputElement | null) => {
			if (node) {
				map.set(id, node);
			} else {
				map.delete(id);
			}
		};
	};

	const getUnitRef = (id: number) => {
		const map = unitRefs.current;
		return (node: HTMLSelectElement | null) => {
			if (node) {
				map.set(id, node);
			} else {
				map.delete(id);
			}
		};
	};

	const getLocationRef = (id: number) => {
		const map = locationRefs.current;
		return (node: HTMLSelectElement | null) => {
			if (node) {
				map.set(id, node);
			} else {
				map.delete(id);
			}
		};
	};

	const getEntryDateRef = (id: number) => {
		const map = entryDateRef.current;
		return (node: HTMLInputElement | null) => {
			if (node) {
				map.set(id, node);
			} else {
				map.delete(id);
			}
		};
	};


	useEffect(() => {
		FetchActiveUsers(setUsers)
		getUnits()
		getLocations()
	}, [setUsers])

	// get dates for each user, populate select
	const GetDatesByUser = async () => {
		if (msg) {
			setMsg("")
		}
		setDates([])
		var userID = ""
		if (userRef && userRef.current && userRef.current.value) {
			userID = userRef.current.value
			console.log(userRef.current.value)
			const response = await fetch(process.env.REACT_APP_API+"/api/dates?user_id="+userID)
			const result = await response.json()
			var dates: string[] = []
			for (var i = 0; i < result.length; i++) {
				dates.push(result[i].substring(0, 10))
			}
			setDates(dates)
			setClockEntries([])
		}
	}


	const GetTimeEntriesByDate = async () => {
		setClockEntries([])
		var userID = ""
		if (userRef && userRef.current) {
			userID = userRef.current.value
		}
		var date = ""
		if (dateRef && dateRef.current) {
			date = dateRef.current.value
		}

		// once date is submitted, get clock entries for that date
		//TODO: Units needs to be a select, with the default unit selected

		const response = await fetch(process.env.REACT_APP_API+"/api/clockEntries?user_id=" + userID + "&date=" + date)
		const result = await response.json()

		var length:number = 0
		if (result.length % 2 === 1) {
			length = result.length - 1
			var newEntry = {id: result[length].id, user_id: result[length].user_id, event: "sign_out", event_date: result[length].event_date, event_time: result[length].event_time, location: result[length].location, unit: result[length].unit}
			result.push(newEntry)
			length++
		} else {
			length = result.length
		}

		var clockEntries: clockEntry[] = []
		for (var i = 0; i < length; i+=2) {
			var entry:clockEntry = {
				entryID: [result[i].id, result[i + 1].id],
				userID: result[i].user_id,
				clockIn: result[i].event_time.substring(11).split(".")[0].replace("Z", ""),
				clockOut: result[i + 1].event_time.substring(11).split(".")[0].replace("Z", ""),
				date: result[i].event_date.substring(0, 10),
				unit: result[i].unit,
				unitID: result[i].unit,
				location: result[i].location,
				locationID: result[i].location
			}
			clockEntries.push(entry)
		}

		setClockEntries(clockEntries)
	}

	const  submitData = async () => {
		interface clockEvent {
			id: number
			user_id: number
			event_time: string|undefined
			event: string|undefined
			event_date: string|undefined
			unit: string|undefined
			location: string|undefined
			entry_method: string;
			entered_by: string;
		}

		var newClockEntries: clockEvent[] = []
		for (var i = 0; i < clockEntries.length; i++) {

			var clockIn:clockEvent = {
				id: clockEntries[i].entryID[0],
				user_id: selectedUser.id,
				event_time: clockInRefs['current'].get(i)?.value,
				event_date: entryDateRef['current'].get(i)?.value,
				unit: unitRefs['current'].get(i)?.value,
				event: "sign_in",
				location: locationRefs["current"].get(i)?.value,
				entry_method: "update",
				entered_by: localStorage.getItem("userID") || ""
			}

			var clockOut:clockEvent = {
				id: clockEntries[i].entryID[1],
				user_id: selectedUser.id,
				event_time: clockOutRefs['current'].get(i)?.value,
				event_date: entryDateRef['current'].get(i)?.value,
				unit: unitRefs['current'].get(i)?.value,
				event: "sign_out",
				location: locationRefs["current"].get(i)?.value,
				entry_method: "update",
				entered_by: localStorage.getItem("userID") || ""
			}

			if (clockIn.event_time && clockOut.event_time && clockIn.event_time > clockOut.event_time) {
				setMsg("Clock in time cannot be after clock out time for time " + clockIn.event_time + " through " + clockOut.event_time)
				return
			}
			
			var clockInTimeVals = clockIn.event_time?.split(":")

			if (clockInTimeVals?.length && clockInTimeVals?.length > 0) {
				var clockInHour = parseInt(clockInTimeVals[0]) + 4
				clockInTimeVals[0] = clockInHour.toString()
				clockIn.event_time = clockInTimeVals?.join(":")
			}
			var clockOutTimeVals = clockOut.event_time?.split(":")
			if (clockOutTimeVals && clockOutTimeVals?.length && clockOutTimeVals?.length > 0) {
				var clockOutHour = parseInt(clockOutTimeVals[0]) + 4
				clockOutTimeVals[0] = clockOutHour.toString()
				clockOut.event_time = clockOutTimeVals?.join(":")
			}
		
			newClockEntries.push(clockIn)
			newClockEntries.push(clockOut)
		}

		try {
			const response = await fetch(process.env.REACT_APP_API+"/api/editTime", {
				method: "PUT",
				headers: {
					"Content-Type": "application/json"
				},
				body: JSON.stringify(newClockEntries)
			})
			if (response.status === 200) {
				setMsg("Timesheet updated successfully")
				// clear values
				if (userRef && userRef.current) {
					userRef.current.value = ""
				}
				if (dateRef && dateRef.current) {
					dateRef.current.value = ""
				}
				setIsUserSet(false)
				if (selectRef && selectRef.current) {
					selectRef.current.setValue({ value: 0, label: "" }, "deselect-option")
				}
			} else {
				setMsg("Error updating timesheet")
			}
		} catch (err) {
			console.log(err)
		}
	}
	// set clock entries, allow editing

	const handleUnitsChange = (e:ChangeEvent, index:number) => {

	}
	const handleLocationsChange = (e:ChangeEvent, index:number) => {

	}

	return (
		<div className="resilire">
			<AdminNavBar />
			<TimesheetNavBar />
			<h3>Edit Timesheet</h3>
			<UserSelect isVisible={isUserSet} setIsVisible={setIsUserSet} setUsers={setUsers} users={users} setSelectedUser={setSelectedUser} ref={userRef} onChange={GetDatesByUser} selectRef={selectRef} />
			{isUserSet && (
				<div className="resilire">
					<label htmlFor="date">Select Date</label>
					<select id="date" name="date" ref={dateRef} onChange={GetTimeEntriesByDate}>
						<option value=""></option>
						{
							dates.map((date) => (
								<option value={date} key={date}>{date}</option>
							))
						}
					</select>

					{clockEntries && clockEntries.map((entry, index) => (
						<div className="resilire" key={entry.entryID[0]}>
							<hr />
							<label htmlFor="date">Date</label>
							<input type="date" id="date" name="date" defaultValue={entry.date} ref={getEntryDateRef(index)} />
							<label htmlFor="unit">Unit</label>
							<select id="units" ref={getUnitRef(index)} defaultValue={entry.unit} onChange={(e) => handleUnitsChange(e, index
							)}>
								{units.map((unit) => (
									<option value={unit.id} key={unit.id} >{unit.unit}</option>
								))}
							</select>
							<label htmlFor="locations">Locations</label>
							<select id="locations" ref={getLocationRef(index)} defaultValue={entry.location} onChange={(e) => handleLocationsChange(e, index
							)}>
								{locations.map((location) => (
									<option value={location.id} key={location.id} >{location.short_name} - {location.long_name}</option>
								))}
							</select>
							{/* <input type="text" id="unit" name="unit" defaultValue={entry.unit} ref={getUnitRef(index)} /> */}
							<label htmlFor="clock_in">Clock In</label>
							<input type="time" id="clock_in" name="clock_in" defaultValue={entry.clockIn} ref={getClockInRef(index)} />
							<label htmlFor="clock_out">Clock Out</label>
							<input type="time" id="clock_out" name="clock_out" defaultValue={entry.clockOut} ref={getClockOutRef(index)} />
						</div>
					))
					}
					{dateRef && dateRef.current && dateRef.current.value !== "" && (
						<div className="resilire">
							<button id="submit" name="submit" onClick={submitData}>Submit</button>
						</div>
					)}

				</div>
			)}

			{msg && (

				<div style={{ color: 'red' }}>
					{msg}
				</div>
			)}
		</div>
	)
}

export default EditTime;
